import AOS from 'aos';
import $ from 'jquery';
import SIMPLE_PARALLAX from 'simple-parallax-js';
import { debounce } from 'lodash';

import 'aos/dist/aos.css';
import '../styles/index.scss';

// スマホ幅判定
const isWindowSp = () => {
  const breakpoint = 841;

  return $(window).width() < breakpoint;
};

// スクロール アニメーション
const startAos = () => {
  let offsetValue = 120;
  if (!isWindowSp()) {
    offsetValue = 250;
  }
  AOS.init({
    duration: 600,
    offset: offsetValue,
    once: true,
  });
};

// TOPページ メインビジュアル
const showTopHero = () => {
  // アニメーション
  const heroAnimations = $(
    '.top-hero__inner, .top-hero__img, .top-hero__icon, .top-hero__sentence, .top-hero__app, .l-header__dropdown'
  );
  heroAnimations.each((i, elm) => {
    const x = i > 0 ? i + 2 : i;
    $(elm)
      .delay(200 * x)
      .queue(() => {
        $(elm).addClass('-active');
      });
  });
};

// SPメニュー
const handleHeaderDropdown = () => {
  const blockName = '.l-header';
  const $dropdown = $(`${blockName}__dropdown`);
  const $dropdownLink = $(`${blockName}__dropdown-link`);
  const $navIcon = $(`${blockName}__nav-button`);
  const openModifier = '-open';
  const closeDropdown = () => {
    $dropdown.removeClass(openModifier);
    $navIcon.removeClass(openModifier);
  };
  $navIcon.on('click', () => {
    if ($navIcon.hasClass(openModifier)) {
      $dropdown.removeClass(openModifier);
      $navIcon.removeClass(openModifier);
    } else {
      $dropdown.addClass(openModifier);
      $navIcon.addClass(openModifier);
    }
  });
  $dropdownLink.on('click', () => {
    closeDropdown();
  });
};

// iphone判別
const isIphone = () => {
  const ua = window.navigator.userAgent.toLowerCase();

  return ua.indexOf('iphone') !== -1 || ua.indexOf('ipad') !== -1;
};

// android判別
const isAndroid = () => {
  const ua = window.navigator.userAgent.toLowerCase();

  return ua.indexOf('android') !== -1;
};

// アプリボタン非表示
const hideAppButton = () => {
  if (isIphone()) {
    $('.top-hero__app .-android, .l-header__dropdown-app .-android').hide();
  }
  if (isAndroid()) {
    $('.top-hero__app .-iphone, .l-header__dropdown-app .-iphone').hide();
  }
};

// ヘッダーメニュー「アプリダウンロード」リンク先変更
const setNavAppDownload = () => {
  if (!isWindowSp()) {
    $('#navAppDownload, #linkAppDownload').attr('href', '/#top');
  }
};

// パララックス表示
const startParallax = () => {
  if (!isWindowSp()) {
    const image = document.getElementsByClassName('js-parallax');
    const parallax = new SIMPLE_PARALLAX(image, {
      orientation: 'down',
      delay: 0.4,
      transition: 'cubic-bezier(0,0,0,1)',
    });
    parallax.refresh();
  }
};

// SP時にメインビジュアルの高さ調節
const adjustTopHero = () => {
  if (isWindowSp()) {
    // ヘッダーの高さ
    const headerHeight = $('.l-header').height();
    // キャッチコピーの高さ
    const heroCopyHeight = $('.c-headline-xl.top-hero__copy').height();
    // キャッチコピー部分の余白
    const heroCopyPadding = 56;
    // 最小値
    const minHeroHeight = 270;
    // prettier-ignore
    const heroHeight = $(window).height() - headerHeight - heroCopyHeight - heroCopyPadding;
    // prettier-ignore
    const adjustHeroHeight = heroHeight < minHeroHeight ? minHeroHeight : heroHeight;
    $('.top-hero__img').css('min-height', `${adjustHeroHeight}px`);
  }
};

// PC（小さいノートPC）時にheaderの高さ調節
const adjustHeaderHeight = () => {
  const $header = $('.l-header__inner');
  if (!isWindowSp() && $(window).height() < 760) {
    $header.addClass('-small');
  }
};

// オーバーレイ要素を非表示
const hideTopOverlay = () => {
  $('.c-content').addClass('-active');
};

// スクロールイベント（headerサイズ変更・ページトップ表示）
const scrollHeaderPageTop = () => {
  const $window = $(window);
  const $header = $('.js-scroll-header');
  const $pagetop = $('.js-scroll-pagetop');
  const $scrollEventPosition = 400;
  $window.on('scroll', () => {
    if ($window.scrollTop() < $scrollEventPosition) {
      $header.removeClass('-active');
      $pagetop.removeClass('-active');
    } else {
      $header.addClass('-active');
      $pagetop.addClass('-active');
    }
  });
};

// 動画用モーダル表示
const showTopModal = () => {
  const $btnOpen = $('.js-open-modal');
  const $btnClose = $('.js-close-modal');
  const $modal = $('.js-modal-window');
  const $video = $('.js-modal-video').get(0);
  $btnOpen.on('click', () => {
    $('body').addClass('top-no-scroll');
    $modal.addClass('-active');
    $video.play(0);
  });
  $btnClose.on('click', () => {
    $video.pause();
    $video.currentTime = 0;
    $('body').removeClass('top-no-scroll');
    $modal.removeClass('-active');
  });
};

// ページ読込時
window.addEventListener('load', () => {
  console.log('rinnai app lp frontend');
  hideTopOverlay();
  hideAppButton();
  handleHeaderDropdown();
  setNavAppDownload();
  adjustTopHero();
  adjustHeaderHeight();
  startAos();
  startParallax();
  showTopHero();
  scrollHeaderPageTop();
  showTopModal();
});

// （PCのみ）ウィンドウサイズ変更時
window.addEventListener(
  'resize',
  debounce(() => {
    const ua = navigator.userAgent.toLowerCase();
    if (!(/android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document)) {
      window.location.reload();
    }
  }, 300)
);

const slider = document.querySelector('#product-slider');
let isDown = false;
let startX = 0;
slider.addEventListener('mousedown', (e) => {
  isDown = true;
  startX = e.pageX - slider.offsetLeft;
});
slider.addEventListener('mouseup', () => {
  isDown = false;
});
slider.addEventListener('mouseleave', () => {
  isDown = false;
});
slider.addEventListener('mousemove', (e) => {
  if (!isDown) {
    return;
  }
  e.preventDefault();
  const x = startX - e.pageX;
  startX = e.pageX;
  const current = slider.scrollLeft;
  slider.scrollLeft = current + x;
});
slider.addEventListener('touchstart', (e) => {
  isDown = true;
  startX = e.targetTouches[0].clientX - slider.offsetLeft;
});
slider.addEventListener('touchend', () => {
  isDown = false;
});
slider.addEventListener('touchmove', (e) => {
  if (!isDown) {
    return;
  }
  e.preventDefault();
  const x = startX - e.targetTouches[0].clientX;
  startX = e.targetTouches[0].clientX;
  const current = slider.scrollLeft;
  slider.scrollLeft = current + x;
});
